module.exports = __webpack_public_path__ + "sharp-sans-bold-ec59f960be6fe7c519f7180fdd47b925.bundle.woff";